import { List, Map } from "immutable"
import * as React from "react"
import { Html } from "../../../Shared/backendApi/Text"
import { Notice } from "../../../Shared/components/Notice"
import { ApiResult, errorText, getActivityEditions, getDatesForPeriod, loadingText, Region } from "../../custom_api/api"
import { ActivityEditionN } from "../../custom_models/activity_edition"
import { emptyOpt, makeOpt } from "../../custom_utils/option"
import { ActivityEdition } from "../components/activity_edition"
import { ActivityEditionList } from "../components/activity_edition_list"
import { Block as BuildingBlock, BlockRenderer } from "../components/block_renderer"
import { Jumbo } from "../components/jumbo"
import { Block, Container } from "../components/library/container"
import { PeriodSlug, RegionAndDateFilter } from "../components/region_and_date_filter"
import { SearchBarWrapper } from "../components/search_bar"

export interface ActivityDetailPageProps {
  readonly kind: "activityDetail"
  readonly activityId: number
  readonly pageTitle: string
  readonly headerTitle: string
  readonly subtitle: string
  readonly description: string
  readonly imageUrl: string
  readonly imageAlt: string
  readonly noticeTitle: string
  readonly noticeContents: string
  readonly regions: ApiResult<Map<string, Region>>
  readonly selectedPeriod: PeriodSlug
  readonly selectedRegion: string
  readonly selectPeriod: (e: React.ChangeEvent<HTMLSelectElement>) => void
  readonly selectRegion: (e: React.ChangeEvent<HTMLSelectElement>) => void
  readonly blocks: List<BuildingBlock>
  readonly pageLanguage: string
}

interface ActivityDetailPageState {
  readonly editions: ApiResult<List<ActivityEditionN>>
}

const activityDetailPageStateZero: ActivityDetailPageState = {
  editions: "loading",
}

export class ActivityDetailPage extends React.Component<ActivityDetailPageProps, ActivityDetailPageState> {
  constructor(props: ActivityDetailPageProps) {
    super(props)

    this.state = activityDetailPageStateZero

    document.title = this.props.pageTitle
  }

  componentDidMount() {
    const p = this.props
    const s = this.state

    if (s.editions == "loading") {
      getActivityEditions({
        cluster: emptyOpt(),
        activity: makeOpt(q => q.Where(a => a.Id.Equals(p.activityId).And(a.HideInOverview.Equals(false)))),
        edition: emptyOpt(),
        region: makeOpt(q =>
          p.selectedRegion
            ? q.Where(r => r.Slug.Equals(p.selectedRegion))
            : q
        ),
        location: emptyOpt(),
        event: makeOpt(q =>
          q.Where(e => {
            let period = getDatesForPeriod(p.selectedPeriod)

            return e.Date.IsAfter(period.start.toDate()).And(e.Date.IsBefore(period.end.toDate()))
          })
        )
      }).then(x => this.setState(s => ({ ...s, editions: x })))
    }
  }

  componentWillReceiveProps(nextProps: ActivityDetailPageProps) {
    const p = this.props
    const np = nextProps

    if (p.selectedPeriod == np.selectedPeriod && p.selectedRegion == np.selectedRegion) return

    this.setState(
      (s, _) => ({ ...s, clusters: "loading" }),
      () => {
        getActivityEditions({
          cluster: emptyOpt(),
          activity: makeOpt(q => q.Where(a => a.Id.Equals(np.activityId).And(a.HideInOverview.Equals(false)))),
          edition: emptyOpt(),
          region: makeOpt(q =>
            np.selectedRegion
              ? q.Where(r => r.Slug.Equals(np.selectedRegion))
              : q
          ),
          location: emptyOpt(),
          event: makeOpt(q =>
            q.Where(e => {
              let period = getDatesForPeriod(np.selectedPeriod)

              return e.Date.IsAfter(period.start.toDate()).And(e.Date.IsBefore(period.end.toDate()))
            })
          )
        }).then(x => this.setState(s => ({ ...s, editions: x })))
      }
    )
  }

  render() {
    const p = this.props
    const s = this.state

    const { blocks, noticeTitle, noticeContents } = p

    const editionsList: JSX.Element = s.editions == "loading" ? <Container><p>{loadingText}</p></Container> :
      s.editions == "error" ? <Container><p>{errorText}</p></Container> :
        s.editions.isEmpty() ? <Container><p>Voor deze activiteit staan er geen edities gepland</p></Container> :
          s.editions.size == 1 ? <Container>{OneEdition(s.editions.first(), blocks, noticeTitle, noticeContents)}</Container> :
            MultipleEditions(s.editions, p)

    const filter: JSX.Element = s.editions != "loading" && s.editions != "error" && s.editions.size != 1 ? <>
      <div className="container-fluid">
        <h2 className="title--l edition-list__title">Kies een editie</h2>
      </div>
      <SearchBarWrapper>
        <RegionAndDateFilter
          enabled={true}
          selectedPeriod={p.selectedPeriod}
          selectedRegion={p.selectedRegion}
          selectPeriod={p.selectPeriod}
          selectRegion={p.selectRegion}
          regions={p.regions}
        />
      </SearchBarWrapper>
    </> : <></>

    return <div className="wide page--activity-detail">
      <Jumbo
        headerTitle={p.headerTitle}
        contents={p.description}
        headerImageUrl={p.imageUrl}
        headerImageAlt={p.imageAlt}
        size="large"
        kind="activity"
      />
      {filter}
      {editionsList}
    </div>
  }
}

const OneEdition: (edition: ActivityEditionN, blocks: List<BuildingBlock>, noticeTitle: string, noticeContents: string) => JSX.Element =
  (e, b, nt, nc) => <ActivityEdition edition={e} blocks={b} noticeTitle={nt} noticeContents={nc} />

const MultipleEditions: (editions: List<ActivityEditionN>, props: ActivityDetailPageProps) => JSX.Element = (e, p) => <>
  <Container>
    <Block><ActivityEditionList editions={e} /></Block>
    <hr />
    <Block>
      <Notice title={p.noticeTitle} description={Html(p.noticeContents)} />
    </Block>
    {!p.blocks.isEmpty() && <hr className="pre-blocks-divider" />}
  </Container>
  <BlockRenderer blocks={p.blocks} />
</>
